export default {
  header: {
    title: 'Beloningen',
  },
  content: {
    title: 'Je hebt {{balance}} punten',
    description:
      'Besteed {{amount}}, verdien {{rewards}} punten! Voeg gratis items toe aan je winkelwagen met je verdiende punten.',
    articles: {
      title: 'Verdien punten bij elke bestelling',
      spend_description: 'Voor elke {{amount}} die je uitgeeft ontvang je {{rewards}} punten op je account.',
      redeem_title: 'Wissel je punten in',
      redeem_description:
        'Wissel je punten in voor gratis beloningen! Begin met sparen vanaf {{minSpendingLimit}} punten, gelijk aan {{amount}} besteed',
      discounts_title: 'Ontdek exclusieve voordelen',
      discounts_description: 'Ontgrendel exclusieve deals, aanbiedingen en kortingen.',
    },
  },
};
